import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext, useRef } from 'react';
import { getInterestForCurrentWiki } from '../utils/getInterestFromWiki';
import IconCloseTiny from '@wikia/react-common/icons/IconCloseTiny';
import useOnClickOutside from 'pathfinder/utils/useOnClickOutside';
import styles from './Tooltip.module.scss';
import { FandomAvatar } from './FandomAvatar';
import { TooltipContext } from './Context';
function getLabel(type, interest) {
    const { name } = interest;
    const optionalThe = name.toLowerCase().startsWith('the ') ? '' : 'the ';
    switch (type) {
        case 'following':
            return (_jsxs(_Fragment, { children: ["You are now following ", _jsx("strong", { children: name }, void 0), ". You can view and manage your saved fandoms in", ' ', _jsx("a", Object.assign({ href: "https://fandom.com/fancentral/home" }, { children: "FanCentral" }), void 0), "."] }, void 0));
        case 'unfollowing':
            return (_jsxs(_Fragment, { children: ["You have unfollowed ", _jsx("strong", { children: name }, void 0), ". You can view and manage your saved fandoms in", ' ', _jsx("a", Object.assign({ href: "https://fandom.com/fancentral/home" }, { children: "FanCentral" }), void 0), "."] }, void 0));
        default:
            return (_jsxs(_Fragment, { children: ["Follow ", optionalThe, _jsx("strong", { children: name }, void 0), " fandom to discover more ", name, " related wikis."] }, void 0));
    }
}
export const Tooltip = ({ variant, isOnScreen }) => {
    const { isVisible, type, onClose } = useContext(TooltipContext);
    const ref = useRef();
    useOnClickOutside(ref, () => onClose());
    if (!isVisible || !isOnScreen) {
        return null;
    }
    const interest = getInterestForCurrentWiki();
    const tooltipClasses = [styles.tooltip];
    switch (variant) {
        case 'desktop-sticky': {
            tooltipClasses.push(styles.desktop);
            tooltipClasses.push(styles.desktopSticky);
            if (type !== 'normal') {
                tooltipClasses.push(styles.following);
                tooltipClasses.push(styles.followingSticky);
            }
            break;
        }
        case 'desktop-non-sticky': {
            tooltipClasses.push(styles.desktop);
            tooltipClasses.push(styles.desktopNonSticky);
            if (type !== 'normal') {
                tooltipClasses.push(styles.following);
                tooltipClasses.push(styles.followingNonSticky);
            }
            break;
        }
        case 'mobile-sticky': {
            tooltipClasses.push(styles.mobile);
            tooltipClasses.push(styles.mobileSticky);
            break;
        }
        case 'mobile-non-sticky': {
            tooltipClasses.push(styles.mobile);
            tooltipClasses.push(styles.mobileNonSticky);
            break;
        }
    }
    const tooltip = (_jsxs("div", Object.assign({ className: tooltipClasses.join(' '), ref: ref }, { children: [_jsx("div", Object.assign({ className: styles.avatar }, { children: _jsx(FandomAvatar, { interest: interest }, void 0) }), void 0), _jsx("div", Object.assign({ className: styles.label }, { children: getLabel(type, interest) }), void 0), _jsx("button", Object.assign({ className: styles.close, onClick: onClose }, { children: _jsx(IconCloseTiny, { className: styles.icon }, void 0) }), void 0)] }), void 0));
    return tooltip;
};
